import { Controller } from "@hotwired/stimulus"

// Local filter for the friends list. Hides cards whose name + email don't
// match the query. Server is never hit.
export default class extends Controller {
  static targets = ["query", "card"]

  filter() {
    const q = (this.queryTarget.value || "").trim().toLowerCase()
    this.cardTargets.forEach((card) => {
      const name = card.dataset.friendName || ""
      const email = card.dataset.friendEmail || ""
      const match = !q || name.includes(q) || email.includes(q)
      card.hidden = !match
    })
  }
}
